import SickDetails from './SickDetails';

export default SickDetails;
